import { VBaseSelect } from '../VBaseSelect';
import VInnerDropdown from './VInnerDropdown';
import type { VDropdownProps } from './type';

const VDropdown = (
  props: VDropdownProps & React.RefAttributes<HTMLButtonElement>,
) => {
  const {
    children,
    disabled,
    fluid,
    loading,
    outlined,
    ref,
    size,
    value,
    variant,
    ...rest
  } = props;
  const vButtonProps = {
    disabled,
    fluid,
    loading,
    outlined,
    size,
    variant,
  };

  return (
    <VBaseSelect {...rest} disabled={disabled} value={value}>
      <VInnerDropdown {...vButtonProps} ref={ref}>
        {children}
      </VInnerDropdown>
    </VBaseSelect>
  );
};

VDropdown.displayName = 'VDropdown';

export default VDropdown;
